import styled from 'styled-components'

export const Label = styled.div`
  margin-bottom: 11px;
  font-weight: 400;
  font-size: 14px;
`

export const BarBackground = styled.div`
  width: 100%;
  height: 6px;
  background: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
`

interface BarFillProps {
  percent: number
  isFinished: boolean
}

export const BarFill = styled.div<BarFillProps>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  background: ${({ isFinished }) => (isFinished ? '#0CB56B' : '#e2e2e2')};
  transition: width 0.3s;
  border-radius: 0 2px 2px 0;
`
